import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCitedSpeech = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 16",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.17 11.04h-1.6c-.3 0-.59-.12-.8-.35a1.23 1.23 0 01-.33-.84V1.2C.44.88.56.57.77.35c.21-.22.5-.35.8-.35h14.3c.3 0 .59.13.8.35.21.22.33.53.33.84v8.66c0 .32-.12.62-.33.84-.21.23-.5.35-.8.35H7.4L3.17 14.4v-3.36z",
			fill: "url(#paint0_linear)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M15.68.5c.22 0 .44.1.6.28.17.17.26.41.26.66v8.64c0 .25-.1.49-.26.66a.83.83 0 01-.6.28H7.36l-.13.1-3.68 3v-3.1H1.76a.83.83 0 01-.6-.28.98.98 0 01-.26-.66V1.44c0-.25.1-.49.26-.66a.83.83 0 01.6-.28h13.92zm0-.5H1.76c-.35 0-.68.15-.93.42a1.5 1.5 0 00-.39 1.02v8.64c0 .38.14.75.39 1.02s.58.42.93.42H3.1v3.6l4.42-3.6h8.17c.35 0 .68-.15.93-.42s.39-.64.39-1.02V1.44c0-.38-.14-.75-.39-1.02a1.27 1.27 0 00-.93-.42z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.53 5.02v.33c0 .1 0 0 0 0a5.15 5.15 0 01-1.15 2.74 5.72 5.72 0 01-2.73 1.7s.9-1.3 1.84-2.59h-.11a2.16 2.16 0 112.15-2.18zM8.36 5.06v.32c0 .11 0 0 0 0A5.15 5.15 0 017.2 8.12a5.72 5.72 0 01-2.73 1.7s.9-1.3 1.84-2.58h-.11a2.16 2.16 0 112.15-2.18z" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear",
			x1: 8.72,
			y1: 0,
			x2: 8.72,
			y2: 14.4,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E1EDF3"
			})]
		}) })
	]
});
export default SvgCitedSpeech;
